<template>
  <v-container class="mt-5">
    <v-card
      class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Modelo de Coparticipação - Editar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn class="mr-1" small @click="update">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader
          v-if="!shareModel"
          type="article, actions"
      ></v-skeleton-loader>

      <v-container fluid>
        <ShareModelForm ref="form" :errors="errors" :share-model="shareModel" v-if="shareModel"></ShareModelForm>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ShareModelForm from "@/view/share_model/_share_model_form"
import {mapErrors} from "@/common/validation"
import {mapActions, mapMutations} from "vuex";

export default {
  components: { ShareModelForm },
  data() {
    return {
      errors: {},
      shareModel: null
    };
  },
  async created() {
    this.shareModel = await this.fetchShareModel(this.$route.params.id);
    this.isLoading = false;
  },
  methods: {
    ...mapActions("shareModel", ["fetchShareModel", "updateShareModel"]),
    ...mapMutations(["toogleDialogLoading"]),
    update() {
      this.toogleDialogLoading(true);

      this.updateShareModel({id: this.shareModel.id, shareModel: this.$refs.form.model()})
          .then((data) => {
            this.$router.push(`/share_model/${data.id}/show`)
          })
          .catch((error) => {
            const errors = [];
            if(error.response.status==409){
              errors.push({field:'code',defaultMessage:error.response.data});
            }
            this.errors = mapErrors(this.$refs.form.model(), errors)
                        
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
    }
  },
};
</script>


